import { useState } from "react";
import { Sample } from "@/comn/components/_";
import { Layout, Button, Pdf, Grid, FormControl } from "@/comn/components";
import { useModal, useFetch, TGridSchema, useGrid, useResource } from "@/comn/hooks";
import "prismjs/themes/prism.css";
import { comnUtils } from "@/comn/utils";

export const SG_IMP_CNTR_RGSR: TGridSchema = {
    id: "impCntrRgsr",
    options: { radio: false, checkbox: true, edit: true, pagination: "in", importExcel: true },
    head: [
        { cells: [{ header: "L_TP", binding: "loadTpCd", width: "*", required: true }] }, // Type !==  Type ==!
        { cells: [{ header: "L_CNTR_NO_CHSS_NO", binding: "cntrNo", width: "*", required: true }] }, // Container No./Chassis No. !==  Container No./Chassis No. ==!
        { cells: [{ header: "L_CNTR_SIZE", binding: "cntrSizeCd", width: "*" }] }, // Container Size !==  Container Size ==!
        { cells: [{ header: "L_SEAL_NO_1", binding: "sealNo1", width: "*" }] }, // Seal No #1 !==  Seal No #1 ==!
        { cells: [{ header: "L_SEAL_NO_2", binding: "sealNo2", width: "*" }] }, // Seal No #2 !==  Seal No #2 ==!
        { cells: [{ header: "L_SEAL_NO_3", binding: "sealNo3", width: "*" }] }, // Seal No #3 !==  Seal No #3 ==!
        { cells: [{ header: "L_FRGH_IDCR", binding: "frghIdcrCd", width: "*" }] }, // Freight Indicator !==  Freight Indicator ==!
        { cells: [{ header: "L_PCKG", binding: "cntrPckgNo", width: "*" }] }, // Package !==  Package ==!
        { cells: [{ header: "L_WGHT", binding: "cntrWght", width: "*", required: true }] }, // Weight !==  Weight ==!
        { cells: [{ header: "L_TMPTR_MIN_MAX", binding: "minTmptr", width: "*" }] }, // Temperature (Min-Max) !==  Temperature (Min-Max) ==!
        { cells: [{ header: "L_REFF_PLUG_YN", binding: "reffPlugYn", width: "*" }] }, // Refer Plug Y/N !==  Refer Plug Y/N ==!
        { cells: [{ header: "L_DATE", binding: "date", width: "*" }] }, // Refer Plug Y/N !==  Refer Plug Y/N ==!
    ],
    body: [
        {
            cells: [
                {
                    binding: "loadTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "CGM0021",
                    excludes: ["B"],
                    required: true,
                    select: false,
                    excel: "B",
                },
            ],
        },
        {
            cells: [{ binding: "cntrNo", letterCase: "upper", maxLength: 50, required: true, excel: "C" }],
        },
        {
            cells: [
                { binding: "cntrSizeCd", type: "select", area: "comnCd", comnCd: "CGM0010", select: false, excel: "D" },
            ],
        },
        {
            cells: [{ binding: "sealNo1", maxLength: 20, excel: "E" }],
        },
        {
            cells: [{ binding: "sealNo2", maxLength: 20, excel: "F" }],
        },
        {
            cells: [{ binding: "sealNo3", maxLength: 20, excel: "G" }],
        },
        {
            cells: [
                { binding: "frghIdcrCd", type: "code", area: "comnCd", comnCd: "CGM0017", select: false, excel: "H" },
            ],
        },
        {
            cells: [
                { binding: "cntrPckgNo", type: "number", maxLength: 18, excel: "I" },
                { binding: "pckgUtCd", select: false, excel: "J" },
            ],
        },
        {
            cells: [
                { binding: "cntrWght", type: "number", maxLength: 18, required: true, excel: "K" },
                { binding: "wghtUtCd", required: true, select: false, excel: "L" },
            ],
        },
        {
            cells: [
                { binding: "minTmptr", type: "number", maxLength: 3, excel: "M" },
                { binding: "maxTmptr", type: "number", maxLength: 3, excel: "N" },
            ],
        },
        {
            cells: [
                {
                    binding: "reffPlugYn",
                    type: "select",
                    select: false,
                    options: [
                        { label: "N", value: "N" },
                        { label: "Y", value: "Y" },
                    ],
                    excel: "O",
                },
            ],
        },
        {
            cells: [{ binding: "date", type: "date", excel: "P" }],
        },
    ],
};

export const GuideExcelUpload = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "CGM0002" }, // !== IMPORT ==!
            { area: "comnCd", comnCd: "CGM0009" }, // !== SIMPLE ==!
            { area: "comnCd", comnCd: "CGM0051" }, // !== PACKING TYPE ==!
            { area: "comnCd", comnCd: "CGM0010" }, // !== CONTAINER SIZE ==!
            { area: "comnCd", comnCd: "CGM0017" }, // !== FCL ==!
            { area: "comnCd", comnCd: "CGM0056" }, // !== OIL ==!
            { area: "comnCd", comnCd: "COM0004" }, // !== 통화단위 ==!
            { area: "comnCd", comnCd: "COM0005" }, // !== 중량단위 ==!
            { area: "comnCd", comnCd: "COM0007" }, // !== 포장단위 ==!
            { area: "comnCd", comnCd: "CGM0021" }, // !== 적재유형 ==!
            { area: "comnCd", comnCd: "CGM0003" }, // !== IMDG ==!
            { area: "cityCd" },
            { area: "coDclaCd" },
            { area: "portCd" },
            { area: "wrhsCd" },
        ],
    });

    const modal = useModal();

    const grid = {
        comCntrRgsr: useGrid({
            defaultSchema: SG_IMP_CNTR_RGSR,
        }),
        comCntrRgsr2: useGrid({
            defaultSchema: SG_IMP_CNTR_RGSR,
        }),
    };

    const render = {
        impMblRgsr: {
            edit: {
                minTmptr: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Layout direction="row" gap={1}>
                            <FormControl
                                type="number"
                                maxLength={3}
                                value={rowValues.minTmptr}
                                onChange={(v) => {
                                    grid.comCntrRgsr.updateRow({ ...rowValues, minTmptr: v });
                                }}
                            />

                            <FormControl
                                type="number"
                                maxLength={3}
                                select={false}
                                value={rowValues.maxTmptr}
                                onChange={(v) => {
                                    grid.comCntrRgsr.updateRow({ ...rowValues, maxTmptr: v });
                                }}
                            />
                        </Layout>
                    );
                },
            }, // end of edit
        },
    };

    return (
        <Sample title="엑셀업로드(Grid에 데이터 추가)" description="">
            <Sample.Section
                title="1. 엑셀업로드 기본 기능"
                description={
                    <div className="leading-5">
                        - 템플릿 관리 기능에서 엑셀 업로드 템플릿 업로드
                        <br />- 주소 :
                        <a
                            href="https://tancis.cupia.or.kr/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0087"
                            target="_blank"
                        >
                            https://tancis.cupia.or.kr/ptli/ptl/btbdms/ptli1018001q?menuId=menu_ptli0087
                        </a>
                        <br />- 내부포털 &gt; 시스템관리 &gt; 템플릿 관리
                        <br />- 해당 템플릿의 게시글 ID (UUID)를 복사하여 템플릿 다운로드 버튼에 적용(소스샘플 참조)
                        <br />- grid...downloadTemplate( 템플릿 UUID )
                        <br />- 그리드 스키마 body 부분에 관련 엑셀 필드 설정( excel=A, B, C... ), 샘플소스의 주석 확잉
                        <br />- 엑셀 업로드 버튼에 비동기 방식 선언(async)
                        <br />- grid...importExcel( {`{ 추가바인딩 , header row 갯수}`} ) 메소드로 그리드에 데이터 추가
                    </div>
                }
            >
                <Sample.Table
                    widths={["w-[15%]", "w-[50%]", "w-auto"]}
                    data={[
                        ["Method", "파라메터", "반환값", "설명"],
                        ["downloadTemplate", "templateId:string", <>- 엑셀 템플릿의 UUID 기재</>],
                        [
                            "importExcel",
                            `TImporttProps : { bindings : 추가 엑셀 바인딩 정보 , headers : 헤더 Row 갯수 , sheet : 엑셀 시트 인덱스( 기본 0) }`,
                            `Array<엑셀데이터>`,
                            `단일 엑셀시트 업로드시 사용`,
                        ],
                        [
                            "importExcels",
                            `TImporttProps[] : Array{ bindings : 추가 엑셀 바인딩 정보 , headers : 헤더 Row 갯수 , sheet : 엑셀 시트 인덱스( 기본 0) } )`,
                            `Array<Array<엑셀데이터>>`,
                            `다중 엑셀시트 업로드시 사용`,
                        ],
                    ]}
                />
                <Sample.Code>{`export const 그리드 스키마: TGridSchema = {
    id: "grid",
    options: { radio: false, checkbox: true, edit: true, pagination: "in" },
    head: [
       ...
    ],
    body: [
        {
            cells: [
                {
                    binding: "loadTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "CGM0021",
                    excludes: ["B"],
                    required: true,
                    select: false,
                    excel: "B", /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */
                },
            ],
        },
        {
            cells: [{ binding: "cntrNo", letterCase: "upper", maxLength: 50, required: true, excel: "C" /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */ }],
        },
        {
            cells: [
                { binding: "cntrSizeCd", type: "select", area: "comnCd", comnCd: "CGM0010", select: false, excel: "D"  /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */},
            ],
        },
        {
            cells: [{ binding: "sealNo1", maxLength: 20, excel: "E"  /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */}],
        },
        {
            cells: [{ binding: "sealNo2", maxLength: 20, excel: "F" /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */ }],
        },
        {
            cells: [{ binding: "sealNo3", maxLength: 20, excel: "G" /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */ }],
        },
        {
            cells: [
                { binding: "frghIdcrCd", type: "select", area: "comnCd", comnCd: "CGM0017", select: false, excel: "H"  /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */},
            ],
        },
        {
            cells: [
                { binding: "cntrPckgNo", type: "number", maxLength: 18, excel: "I" },
                { binding: "pckgUtCd", select: false, excel: "J"  /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */},
            ],
        },
        {
            cells: [
                { binding: "cntrWght", type: "number", maxLength: 18, required: true, excel: "K" },
                { binding: "wghtUtCd", required: true, select: false, excel: "L" /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */ },
            ],
        },
        {
            cells: [
                { binding: "minTmptr", type: "number", maxLength: 3, excel: "M"  /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */},
                { binding: "maxTmptr", type: "number", maxLength: 3, excel: "N" /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */ },
            ],
        },
        {
            cells: [
                {
                    binding: "reffPlugYn",
                    type: "select",
                    select: false,
                    options: [
                        { label: "N", value: "N" },
                        { label: "Y", value: "Y" },
                    ],
                    excel: "O", /* 엑셀업로드시 업로드할 데이터의 엑셀필드를 지정 */
                },
            ],
        },
    ],
};
...
/* 템플릿 다운로드 버튼 */
<Button
    role="tmplDown"
    onClick={() => {
        /* downloadTemplate( 템플릿관리에 업로드한 파일의 UUID ) */        
        grid.comCntrRgsr.downloadTemplate("1aae5c07-8822-06c7-e063-020011ac0e40");
    }}
></Button>
/* 엑셀 업로드 (기존 데이터에 추가) */
<Button
    role="excelUpload"
    // async 로 비동기 호출 방식으로 지정
    onClick={async () => {
        // 업로드할 엑셀 파일을 선택하여 엑셀 파일 Parsing 후 데이터를 return
        // await 를 사용하여 엑셀 데이터를 처리 완료 할때까지 기다린 후 실행
        // headers : 엑셀의 Header Row의 갯수를 지정하여 데이터 Parsing 시 데이터에 들어가지 않도록 처리( 기본값 1 )
        // bindings : 그리드 스키마에 지정된 셀 이외의 다른 셀도 업로드 데이터에 추가 할 경우 Cell Name : binding 으로 값을 추가하여 처리 가능
        const data = await grid.comCntrRgsr.importExcel({
            headers: 2,
            bindings: {
                A: "mblNo",
                Z: "sealNo4",
            },
            sheet : 0
        });
        // 업로드 된 엑셀 데이터를 그리드에 기존 데이터(grid...getData())에 추가(Append)
        grid.comCntrRgsr.setData(
            comnUtils.getGridData([...grid.comCntrRgsr.getData(), ...data]),
        );
    }}
></Button>
/* 엑셀 업로드 (다중 시트 업로드) */
<Button
    role="excelUpload"
    onClick={async () => {
        // 엑셀 업로드 옵션을 배열로 여러개를 세팅하여 업로드 실행
        const data = await grid.comCntrRgsr.importExcels([
            {
                headers: 1,
                bindings: {
                    A: "mblNo",
                },
                sheet: 0, // 업로드할 시트의 index
            },
            {
                headers: 1,
                bindings: {
                    A: "mblNo",
                },
                sheet: 1, // 업로드할 시트의 index
            },
        ]);

        // 엑셀을 시트별로 읽어들여 data[0] , data[1] 와 같이 배열 형태로 리턴

        grid.comCntrRgsr.setData(
            comnUtils.getGridData([...grid.comCntrRgsr.getData(), ...data[0]]),
        );
        grid.comCntrRgsr2.setData(
            comnUtils.getGridData([...grid.comCntrRgsr2.getData(), ...data[1]]),
        );
    }}
></Button>

/* 엑셀 업로드 (기존 데이터 대체) */
 <Button
    role="excelUpload"
    onClick={async () => {
        const data = await grid.comCntrRgsr.importExcel();

        // 업로드 된 엑셀 데이터로 기존 데이터를 대체(Replace)
        grid.comCntrRgsr.setData(comnUtils.getGridData(data));
    }}
></Button>

`}</Sample.Code>
                <Layout>
                    <Layout.Left>
                        <Button
                            role="tmplDown"
                            onClick={() => {
                                grid.comCntrRgsr.downloadTemplate("1aae5c07-8822-06c7-e063-020011ac0e40");
                            }}
                        ></Button>
                        <Button
                            role="excelUpload"
                            onClick={async () => {
                                const data = await grid.comCntrRgsr.importExcel({
                                    headers: 1,
                                    bindings: {
                                        A: "mblNo",
                                    },
                                    sheet: 0,
                                });
                                grid.comCntrRgsr.setData(
                                    comnUtils.getGridData([...grid.comCntrRgsr.getViewData(), ...data]),
                                );
                            }}
                        ></Button>
                        <Button
                            role="excelUpload"
                            onClick={async () => {
                                const data = await grid.comCntrRgsr.importExcels([
                                    {
                                        headers: 1,
                                        bindings: {
                                            A: "mblNo",
                                        },
                                        sheet: 0,
                                    },
                                    {
                                        headers: 1,
                                        bindings: {
                                            A: "mblNo",
                                        },
                                        sheet: 1,
                                    },
                                ]);

                                grid.comCntrRgsr.setData(
                                    comnUtils.getGridData([...grid.comCntrRgsr.getData(), ...data[0]]),
                                );
                                grid.comCntrRgsr2.setData(
                                    comnUtils.getGridData([...grid.comCntrRgsr2.getData(), ...data[1]]),
                                );
                            }}
                        ></Button>
                        <Button
                            role="excelUpload"
                            onClick={async () => {
                                const data = await grid.comCntrRgsr.importExcel();

                                //시트명, 헤더 ROW 수
                                grid.comCntrRgsr.setData(comnUtils.getGridData(data));
                            }}
                        ></Button>
                        <Button
                            role="excelDown"
                            onClick={async () => {
                                grid.comCntrRgsr.exportExcel({ excelName: "Download", sheetName: "My Sheet" });
                            }}
                        ></Button>
                    </Layout.Left>
                    <Layout.Right>
                        <Button
                            role="gridAdd"
                            onClick={() => {
                                grid.comCntrRgsr.addRow();
                            }}
                        ></Button>
                        {/* Delete !==  Delete ==! */}
                        <Button
                            role="gridDelete"
                            onClick={() => {
                                grid.comCntrRgsr.deleteRow("checkbox");
                            }}
                        ></Button>
                        <Button
                            onClick={() => {
                                grid.comCntrRgsr.setOption("edit", false);
                            }}
                        >
                            Edit
                        </Button>
                    </Layout.Right>
                </Layout>
                <Layout>
                    <Grid {...grid.comCntrRgsr.grid} render={render.impMblRgsr} />
                </Layout>
                <Layout>
                    <Grid {...grid.comCntrRgsr2.grid} render={render.impMblRgsr} />
                </Layout>
            </Sample.Section>
        </Sample>
    );
};
